import React from 'react'
import { Route, RouteProps } from 'react-router-dom'
import Loader from 'components/Loader/Loader'
import useAuthHook from 'hooks/use-auth'
import SSO from '../SSO/SSO'

interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>
}

const ProtectedRoute = ({ component: Component, ...routeProps }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuthHook()

  if (isLoading) {
    return <Loader open />
  }

  if (!isAuthenticated && !isLoading) {
    return <SSO />
  }

  return (
    <Route {...routeProps}>
      <Component />
    </Route>
  )
}

export default ProtectedRoute
